import {Button, Form, Row, Space, Spin, Table} from "antd";
import {ButtonExcel, ExpandSearch} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {columnsTable, dataField} from "./config";
import dayjs from "dayjs";
import {examOutService} from "api";
import Notification from "components/common/notification/notification";
import {exportFile, formatDateToString} from "helper/common";

const ReportRevenue = () => {
  const expandRef = useRef<any>();

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(columnsTable);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [params, setParams] = useState({
    // limit: 10,
    // page: 1,
    ngayBatDau: dayjs(),
    ngayKetThuc: dayjs(),
  });

  const onClickSearchButton = async () => {
    try {
      const searchFields = await expandRef.current?.getValidateField();
      setParams({
        ...params,
        ...searchFields,
        // page: 1,
      });
    } catch (error) {}
  };
  const formatParams = () => {
    return {
      ...params,
      ngayBatDau: formatDateToString(params.ngayBatDau),
      ngayKetThuc: formatDateToString(params.ngayKetThuc),
    };
  };
  const getData = async () => {
    setLoading(true);
    try {
      const response = await examOutService.getDataReportRevenueKB(
        formatParams()
      );
      setLoading(false);
      const newData = response?.map(e => ({
        ...e,
        key: e.id,
      }));
      setData(newData);
      setTotalPage(newData?.length);
      // Notification("success", "Lấy thông tin báo cáo thành công");
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin báo cáo");
    }
  };

  useEffect(() => {
    getData();
  }, [params]);

  const getReportRevenueByBacSyFile = async () => {
    const param = formatParams();
    if (param?.ngayBatDau != null || param.ngayKetThuc !== null) {
      exportFile(
        "/qlkhambenh/bao-cao-tong-hop/doanh-thu-theo-bac-sy",
        {ngayBatDau: param?.ngayBatDau, ngayKetThuc: param?.ngayKetThuc},
        `Báo cáo doanh thu theo bác sỹ`
      );
    } else {
      Notification("error", "");
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    // setParams({
    //   ...params,
    //   // page: page,
    //   // limit: pageSize,
    // });
    setLimit(pageSize);
    setPage(page);
  };

  const paginationConfig = {
    current: page,
    total: totalPage,
    showSizeChanger: true,
    pageSize: limit,
    onChange: handlePaginationChange,
  };
  columnsTable.find(e => e.dataIndex === "stt").render = (v, r, i) =>
    (page - 1) * limit + i + 1;
  return (
    <Spin spinning={loading}>
      <div>
        <div className="container">
          <Space direction="vertical" style={{width: "100%"}}>
            <ExpandSearch
              ref={expandRef}
              onClickSearch={onClickSearchButton}
              fields={dataField}
              initialValues={params}
              isSearch={true}
              isExportExcel={false}
              isResetField={false}
              isSearchExpend={false}
              isShowDetail={false}
              // handleExportExcel={getReportFile}
            >
              {/* <ButtonExcel onClick={getReportRevenueByBacSyFile} title="Xuất báo cáo doanh thu theo bác sỹ"></ButtonExcel> */}
            </ExpandSearch>
          </Space>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            columns={columns}
            // scroll={{x: 2000}}
          />
        </div>
      </div>
    </Spin>
  );
};

export default ReportRevenue;
